import type { AssetPosition } from "kubb";
import type React from "react";
import type { Asset } from "../../../../../utils/object.tsx";
import AssetDataSelectorUrlQuerySetter from "../../AssetDataSelectorUrlQuerySetter.tsx";
import NewAssetDataSearchStringParser from "../NewAssetDataSearchStringParser.tsx";
import AssetRFChart from "./AssetRFChart";
import AssetTimeSeriesRFGetter from "./AssetTimeSeriesRFGetter";

interface Props {
  device: Asset;
  assetPosition: AssetPosition;
}

export default function AssetRFAssessmentContainer(
  props: Props,
): React.ReactElement {
  function InnerRFContainer({
    params,
    initialized,
  }: {
    initialized?: boolean;
    params?: any;
  }): React.ReactElement {
    return (
      <>
        {initialized && (
          <>
            <AssetDataSelectorUrlQuerySetter
              device={props.device}
              params={params}
              showProjection={false}
            />
            <AssetTimeSeriesRFGetter
              device={props.device}
              searchParams={params}
              render={(props) => <AssetRFChart {...props} />}
            />
          </>
        )}
      </>
    );
  }

  return (
    <NewAssetDataSearchStringParser initialState={{ projection: "parsed" }}>
      <InnerRFContainer />
    </NewAssetDataSearchStringParser>
  );
}
